<template>
  <google-map
    v-if="google"
    :google="google"
    :handleKeyPress="attemptPathTravel"
    :zoom="10"
    :hideFilterInfo="true"
    :sprayDataPoint="sprayDataPoint"
    :selectedZone="selectedAdulticideZone"
    :showSprayReminderMarkersForSprayPaths="showSprayReminders"
    :draggable="true"
  >
    <template
      slot-scope="{
        google,
        map,
        clearBound,
        provideBound,
        fitBound,
        sprayDataPoint,
      }"
    >
      <div v-for="mappable in mapAdulticides" :key="mappable.id">
        <keep-alive>
          <map-marker
            :mappable="mappable"
            :google="google"
            :map="map"
            :key="mappable.id"
            :fade="shouldFade(mappable)"
            :clearBound="clearBound"
            :provideBound="provideBound"
            :fitBound="fitBound"
            :sprayDataPoint="sprayDataPoint"
            :showNoSprayMarkersForSprayPaths="showNoSprays"
            :showSprayReminderMarkersForSprayPaths="showSprayReminders"
          />
        </keep-alive>
      </div>
    </template>
  </google-map>
</template>

<script>
import GoogleMap from '../../map/google-map';
import MapMarker from '../../map/map-marker';
import { mapGetters } from 'vuex';
import ZonesService from '../../../services/ZonesService';
import loadGoogle from '../../../utils/google-maps';

export default {
  name: 'spray-paths-map',

  components: {
    GoogleMap,
    MapMarker,
  },

  props: {},

  data() {
    return {
      loading: false,
      google: window.google,
    };
  },

  computed: {
    ...mapGetters(['mapAdulticides', 'selectedAdulticideZone']),
    shouldFade() {
      const { selectedAdulticide } = this.$store.state.sprayPaths;
      return selectedAdulticide === null
        ? () => false
        : (adulticide) => adulticide !== selectedAdulticide;
    },
    sprayDataPoint() {
      return this.$store.state.sprayPaths.pathDataPoint;
    },
    showNoSprays() {
      const { filters } = this.$store.state.sprayPaths.settings;
      const showNoSprays = filters.siteTypes['No Spray'];
      return showNoSprays;
    },
    showSprayReminders() {
      const { filters } = this.$store.state.sprayPaths.settings;
      const showSprayReminders = filters.siteTypes['Spray Reminder'];
      return showSprayReminders;
    },
  },

  methods: {
    attemptPathTravel(e) {
      const left = e.keyCode === 37;
      if (left) {
        this.$store.commit('decreasePathIndex');
        return;
      }
      const right = e.keyCode === 39;
      if (right) {
        this.$store.commit('increasePathIndex');
      }
    },
  },

  mounted() {
    const { $store } = this;
    $store.commit('setSelectedAdulticide', { adulticide: null });
    if ($store.state.map.zones.length <= 1) {
      ZonesService.getList().then(({ data }) => {
        const zones = data.map(({ id, attributes }) => {
          const { coordinates, name } = attributes;
          const points = coordinates.map(({ lat, lon }) => ({
            lat,
            lng: lon,
          }));
          return {
            id,
            name,
            points,
          };
        });
        $store.commit('setMapZones', zones);
        $store.commit('setZonesForSprayPaths', zones);
      });
    }

    const $this = this;
    const onLoad = function() {
      $this.google = window.google;
    };
    loadGoogle(onLoad);
  },
};
</script>

<style></style>
